import React, { Component } from 'react';

import _ from "lodash";
import classnames from "classnames";
import { Form, Message } from 'semantic-ui-react'

import { translate } from "../../addons/Translate";

class EmailForm extends Component {
	state = {
		data: {
			attach_cv: !!this.props.data.attach_cv ? this.props.data.attach_cv : "",
			attach_id: !!this.props.data.attach_id ? this.props.data.attach_id : "",
			attach_certificate: !!this.props.data.attach_certificate ? this.props.data.attach_certificate : "",
			attach_face: !!this.props.data.attach_face ? this.props.data.attach_face : "",
		},
		loading: false,
		error_server: false,
		errors_response: {},
		errors: {},
	}

	componentWillReceiveProps(props) {
		this.setState({
			data: {
				attach_cv: !!props.data.attach_cv ? props.data.attach_cv : "",
				attach_id: !!props.data.attach_id ? props.data.attach_id : "",
				attach_certificate: !!props.data.attach_certificate ? props.data.attach_certificate : "",
				attach_face: !!props.data.attach_face ? props.data.attach_face : "",
			}
		})
	}

	onChange = e => {
		const data = {...this.state.data, [e.target.name]: e.target.files[0]};

		if(e.target.files[0].size > 5242880) {
			this.setState({
				errors: {
					...this.state.errors,
					[e.target.name]: true
				}
			});

			return;
		}

		this.props.onUpdate(data);

		if(this.state.errors[e.target.name] !== undefined) {
			this.setState({
				errors: _.omit(this.state.errors, e.target.name)
			});
		}
	}

	onSubmit = e => {
		e.preventDefault();
		const errors = this.validate(this.state.data);
		
		this.setState({ errors });

		if(Object.keys(errors).length === 0) {
			this.props.onSubmit()
			.catch(err => {
				// console.log(err);
				if(err !== undefined) {
					this.setState({
						loading: false,
						errors_response: {
							code: err
						}
					});
				} else {
					this.setState({
						error_server: true,
						loading: false
					});
				}
			});
		}
	}

	uploadCV(e){
		// console.log(e.target.files[0]);
	}

	validate(data) {
		const { file_cv_option, file_id_option, file_face_option, file_certificate_option } = window.restaurant.settings;
		const errors = {};

		if(file_cv_option === 1 && !data.attach_cv) errors.attach_cv = true;
		if(file_id_option === 1 && !data.attach_id) errors.attach_id = true;
		if(file_face_option === 1 && !data.attach_face) errors.attach_face = true;
		if(file_certificate_option === 1 && this.props.data.qualifications > 3 && !data.attach_certificate) errors.attach_certificate = true;

		console.log(errors);

		return errors;
	}

	renderErrorMessage() {
		const { errors_response, error_server } = this.state;

		if(error_server) {
			return (
				<Message negative>
				    <p>{translate("xxltable.errors.server")}</p>
				</Message>
			);
		}

		if(Object.keys(errors_response).length > 0) {
			return (
				<Message negative>
					{Object.keys(errors_response).map(error => <div key={error}>{errors_response[error]}</div>)}
				</Message>
			);
		}

		return null;
	}

	render() {
		const { data, errors, loading } = this.state;
		const { file_cv_option, file_id_option, file_face_option, file_certificate_option } = window.restaurant.settings;

		return (
			<Form onSubmit={this.onSubmit.bind(this)} loading={loading}>
				{this.renderErrorMessage()}

				{ file_cv_option < 3 &&
					(
						<div className="attach-field">
							<strong>{translate("xxltable.step4.head_cv")}</strong>
							<p>{translate("xxltable.step4.desc_cv")} ({translate("xxltable.max_file_size", {":size": "5MB"})})</p>
					        
					        <label htmlFor="attach_cv" className={classnames('ui', 'icon', 'button', {red: !!errors.attach_cv}, {green: data.attach_cv !== ""})}>
					             <i className="attach icon"></i> {translate("xxltable.step4.btn_choose_cv")}
					             <input ref="attach_cv" type="file" id="attach_cv" name="attach_cv" style={{display: "none"}} onChange={this.onChange.bind(this)} accept="image/jpeg,image/png,application/pdf" />
					        </label>
					    </div>
					)
				}

			    { file_id_option < 3 &&
					(
						<div className="attach-field">
							<strong>{translate("xxltable.step4.head_photo")}</strong>
							<p>{translate("xxltable.step4.desc_photo")} ({translate("xxltable.max_file_size", {":size": "5MB"})})</p>
						        
					        <label htmlFor="attach_id" className={classnames('ui', 'icon', 'button', {red: !!errors.attach_id}, {green: data.attach_id !== ""})}>
					             <i className="attach icon"></i> {translate("xxltable.step4.btn_choose_photo")}
					             <input ref="attach_id" type="file" id="attach_id" name="attach_id" style={{display: "none"}} onChange={this.onChange.bind(this)} accept="image/jpeg,image/png" />
					        </label>
					    </div>
					)
				}

			    { file_certificate_option < 3 && this.props.data.qualifications > 3 &&
			    	(
			    		<div className="attach-field">
							<strong>{translate("xxltable.step4.attach_certificate.head")}</strong>
							<p>{translate("xxltable.step4.attach_certificate.desc")} ({translate("xxltable.max_file_size", {":size": "5MB"})})</p>
						        
					        <label htmlFor="attach_certificate" className={classnames('ui', 'icon', 'button', {red: !!errors.attach_certificate}, {green: data.attach_certificate !== ""})}>
					             <i className="attach icon"></i> {translate("xxltable.step4.attach_certificate.btn")}
					             <input ref="attach_certificate" type="file" id="attach_certificate" name="attach_certificate" style={{display: "none"}} onChange={this.onChange.bind(this)} accept="image/jpeg,image/png,application/pdf" />
					        </label>
					    </div>
					)
				}
			    
			    { file_face_option < 3 &&
					(
						<div className="attach-field">
							<strong>{translate("xxltable.step4.attach_face_photo.head")}</strong>
							<p>{translate("xxltable.step4.attach_face_photo.desc")} ({translate("xxltable.max_file_size", {":size": "5MB"})})</p>
						        
					        <label htmlFor="attach_face" className={classnames('ui', 'icon', 'button', {red: !!errors.attach_face}, {green: data.attach_face !== ""})}>
					             <i className="attach icon"></i> {translate("xxltable.step4.attach_face_photo.btn")}
					             <input ref="attach_face" type="file" id="attach_face" name="attach_face" style={{display: "none"}} onChange={this.onChange.bind(this)} accept="image/jpeg,image/png" />
					        </label>
					    </div>
					)
				}

				<div className="ui center aligned container">
					<Form.Button positive>{translate("xxltable.step4.btn_next")}</Form.Button>
				</div>
			</Form>
		);
	}
}

export default EmailForm;


// WEBPACK FOOTER //
// ./src/components/forms/AttachementForm.js